import { api } from './index';

export const promoCampaignSubscriptionsApi = {
  create(recommenderId: number, promoCampaignId: number) {
    const path = '/api/internal/promo_campaign_subscriptions';

    return api({
      method: 'post',
      url: path,
      data: { recommenderId, promoCampaignId },
    });
  },
};
